<template>
  <WsMain>
    <WsCRUD
      ref='WsCRUD'
      v-if="isMounted"
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :showFields="showFields"
      :showExpand="false"
      :pageMode="true"
      :inRowBtnRead="false"
      :inRowBtnUpdate="false"
      :inRowBtnDelete="false"
      :rowClickEmit="true"
      :filterSelects="filterSelects"
      :filterProps="filterProps"
      :isCreatable="false"
      :customUrlParams="_customUrlParams"
      :isMultiSelect="true"
      :hasMultiDeleteBtn="false"
      @filter-select="$_onFilterSelect($event)"
      @rowClickInput="$_onClickAct($event)"
    >
      <template v-slot:titlebarCustomBtns>
        <WsBtn
          class="ml-2"
          @click="$_onOpenDialog()"
        >
          <v-icon>mdi-plus</v-icon>
          <div>添加{{label}}</div>
        </WsBtn>
      </template>
      <template v-slot:customBtns="{item}">
        <WsIconBtn
          tooltip="查看"
          tooltipPosition="top"
          class="ml-1 mr-1"
          @click.stop="$_onClickAct(item.id)"
        >mdi-eye</WsIconBtn>
        <WsIconBtn
          tooltip="移除"
          tooltipPosition="top"
          class="ml-1 mr-1"
          @click.stop="$_onRemoveAct(item.id)"
        >mdi-block-helper</WsIconBtn>
      </template>
      <template v-slot:multiSelectCustomBtns="{items}">
        <WsIconBtn
          tooltip="移除"
          tooltipPosition="top"
          class="ml-1 mr-1"
          @click.stop="$_onRemoveMultiActs(items)"
        >mdi-block-helper</WsIconBtn>
      </template>
    </WsCRUD>
    <WsDialog
      v-model="isDialogShow"
      class="pb-2"
      ref="WsDialog"
      @close="$_onCloseDialog()"
      :title="`新增訂閱法規`"
    >
      <template v-slot:content>
        <div v-if="step===1">
          <WsCRUD
            :modelName="'act'"
            :label="'法規'"
            :fields="dialogFields"
            :sortBy="'name'"
            :showFields="dialogShowFields"
            :pageMode="true"
            :showExpand="false"
            :rowClickRead="false"
            :rowClickEmit="true"
            :isShowBtn="false"
            :liveSearching="true"
            :isMultiSelect="false"
            :showTitlebar="false"
            :hasSearchBtn="false"
            :customParams="_customDialogParams"
            noChangePage
            @rowClickInput="$_onSelectAct($event)"
          >
          </WsCRUD>
        </div>
        <div v-if="step===2">
          <v-progress-linear
            v-if="isLoading.dialogContent"
            absolute
            indeterminate
            color="loadingBar"
          ></v-progress-linear>
          <WsInfo
            v-else
            :label="'法規名稱'"
            :type="'text'"
            :value="dialogState.name"
          ></WsInfo>
        </div>
      </template>
      <template v-slot:leftActions>
        <div v-if="step === 2">
          <WsBtn
            @click="$_onPreviousStep()"
            minWidth="100px"
            color="textSecondary"
            outlined
          >上一步</WsBtn>
        </div>
      </template>
      <template v-slot:rightActions>
        <div v-if="step === 2">
          <WsBtn
            @click="$_onSubmit()"
            minWidth="100px"
            :loading="isLoading.dialogSubmit"
            color="primary"
          >送出</WsBtn>
        </div>
      </template>
    </WsDialog>
  </WsMain>
</template>

<script>
import model from "@/models/act";
export default {
  data: () => ({
    isMounted: false,
    modelName: model.modelName,
    label: '本工廠訂閱法規清單',
    fields: model.fields,
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        placeholder: "請選擇地區",
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        label: "",
        type: "hasMany",
        textKey: "name",
        modelName: "area_section",
        placeholder: "請選擇子地區",
        hasNoSearch: true,
        hasAllSelectBtn: true,
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        type: "multiple-layer-select",
        label: "",
        textKey: "name",
        modelName: "system_subclasses",
        getUrl: "system_class",
        placeholder: " 領域",
        orderBy: "sequence",
        orderWay: "asc",
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "act_type",
        placeholder: "篩選法規類別",
      },
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "admin",
        paramName: "updated_admin",
        placeholder: "最後更新人",
      },
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "is_active",
        defaultValue: "1",
        items: [
          {
            value: "1",
            text: "啟用",
          },
          {
            value: "0",
            text: "停用",
          },
        ],
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "act_status",
        placeholder: "篩選法規狀態",
      },
      {
        type: "select",
        label: "",
        modelName: "act_idtf_status",
        placeholder: "篩選鑑別狀態",
        textKey: "name",
        items: [
          {
            text: "全部",
            value: "",
          },
          {
            text: "從未有鑑別",
            value: "1",
          },
          {
            text: "編輯草稿中",
            value: "2",
          },
          {
            text: "鑑別進行中",
            value: "3",
          },
          {
            text: "已完成鑑別",
            value: "4",
          },
        ],
        defaultValue: "",
      },
      {
        type: "select",
        label: "",
        modelName: "range_type",
        placeholder: "篩選適用範圍類型",
        textKey: "name",
        items: [
          {
            text: "所有類型",
            value: "",
          },
          {
            text: "通用",
            value: "general",
          },
          {
            text: "專屬",
            value: "exclusive",
          },
        ],
        defaultValue: "",
      },
      {
        type: "hasMany",
        label: "",
        modelName: "factory",
        paramName: "exclusive_factories",
        placeholder: "篩選專屬工廠",
        textKey: "name",
        getText(item) {
          return this.$_CMS_getFactoryName(item);
        },
      },
      {
        type: "hasMany",
        label: "",
        modelName: "factory",
        paramName: "factories",
        placeholder: "篩選適用工廠",
        textKey: "name",
        getText(item) {
          return this.$_CMS_getFactoryName(item);
        },
      },
    ],
    filterProps: {},
    showFields: [
      "id",
      "sequence",
      "act_status",
      "name",
      "act_idtf_status",
      "act_type",
      "areas",
      "area_sections",
      "system_classes",
      "system_subclasses",
      "updated_at",
      "updated_admin",
    ],
    isDialogShow: false,
    step: 1,
    dialogFields: {
      name: {
        label: "法規名稱",
        type: "text",
        width: "300px",
        readonly: true,
      },
    },
    dialogShowFields: ["name"],
    dialogState: {
      id: null,
      name: "",
      orderBy: "announce_at",
      orderWay: "desc",
    },
    isLoading: {
      dialogContent: false,
      dialogSubmit: false
    },
  }),
  computed: {
    _currentFactoryId() {
      return this.$route.params.id
    },
    _customDialogParams() {
      const customParams = {};
      customParams.order_way = this.dialogState.orderWay;
      customParams.order_by = this.dialogState.orderBy;
      customParams.is_active = 1;
      return customParams;
    },
    _customUrlParams() {
      return {
        subscription_factories: this._currentFactoryId
      }
    }
  },
  methods: {
    async $_filtersSet() {
      try {
        const res = await this.$axios.get("/system_class");
        res.data.data.forEach((systemClassItem) => {
          this.filterSelects[0].items.push({
            value: systemClassItem.id,
            text: systemClassItem.name,
          });
        });
        this.isMounted = true;
      } catch (error) {
        alert("領域取得錯誤");
      }
    },
    $_onFilterSelect($event) {
      if ($event && ($event.exclusive_factories || $event.factories)) {
        if (this.filterProps.range_type != $event.range_type) {
          if ($event.range_type === "exclusive") {
            this.filterProps = {
              ...$event,
              factories: null,
            };
          } else if ($event.range_type === "general") {
            this.filterProps = {
              ...$event,
              exclusive_factories: null,
            };
          } else if ($event.range_type === "") {
            this.filterProps = {
              ...$event,
              factories: null,
              exclusive_factories: null,
            };
          }
        } else {
          this.filterProps = {
            ...$event,
          };
        }
      } else {
        this.filterProps = {
          ...$event,
        };
      }
    },
    $_onClickAct(id) {
      const ActPage = this.$router.resolve(`/act/${id}`)
      window.open(ActPage.href,'_blank')
    },
    async $_onRemoveAct(id) {
      try {
        const params = {
          subscription_acts: typeof id === 'object'
            ? id
            : [id]
        }
        await this.$axios.post(`/factory/${this._currentFactoryId}/remove/subscription_act`, params)
        if (typeof id === 'object') {
          id.forEach(_id => {
            this.$refs.WsCRUD.$_removeModeldataById(_id)
          })
        } else {
          this.$refs.WsCRUD.$_removeModeldataById(id)
        }
      } catch (error) {
        alert(error)
      }
    },
    $_onOpenDialog() {
      this.step = 1
      this.isDialogShow = true
    },
    $_onCloseDialog() {
      this.isDialogShow = false;
    },
    async $_onSelectAct($event) {
      try {
        this.step++;
        this.isLoading.dialogContent = true
        this.dialogState = {
          ...this.dialogState,
          id: null,
          name: "",
        }
        const res = await this.$axios.get(`/act/${$event}`);
        this.dialogState.name = res.data.data.last_version.name;
        this.dialogState.id = $event;
        this.isLoading.dialogContent = false
      } catch (error) {
        this.isLoading.dialogContent = false
        alert(error);
      }
    },
    $_onPreviousStep() {
      this.step--;
    },
    async $_onSubmit() {
      try {
        this.isLoading.dialogSubmit = true
        const params = {
          subscription_acts: [this.dialogState.id]
        }
        await this.$axios.post(`factory/${this._currentFactoryId}/add/subscription_act`, params)
        this.isLoading.dialogSubmit = false
        this.$_onCloseDialog();
        this.$refs.WsCRUD.$_fetchData("SubAct")
      } catch (error) {
        this.isLoading.dialogSubmit = false
        alert(error);
        this.$_onCloseDialog();
      }
    },
    async $_onRemoveMultiActs(items) {
      const itemIdList = items.map(item => item.id)
      await this.$_onRemoveAct(itemIdList)
    }
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>